<template>
  <a-card>
    <div>
      审批结果通知邮箱：
      <a-input
        placeholder="两个邮箱之间以分号间隔"
        v-model="bpm"
        class="email-input"
      />
      <a-button type="primary" @click="handleSave('1')">确定</a-button>
    </div>
    <br />
    <div>
      信用日报接收邮箱：
      <a-input
        placeholder="两个邮箱之间以分号间隔"
        v-model="amount"
        class="email-input"
      />
      <a-button type="primary" @click="handleSave('2')">确定</a-button>
    </div>
    <br />
    <div>
      限额超担保和保险预警接收邮箱：
      <a-input
        placeholder="两个邮箱之间以分号间隔"
        v-model="limitOverAmount"
        class="email-input"
      />
      <a-button type="primary" @click="handleSave('3')">确定</a-button>
    </div>
    <br />
    <div>
      额度超限额预警接收邮箱：
      <a-input
        placeholder="两个邮箱之间以分号间隔"
        v-model="loanOverLimit"
        class="email-input"
      />
      <a-button type="primary" @click="handleSave('4')">确定</a-button>
    </div>
    <br />
    <div>
      担保归档人员：
      <a-select
        show-search
        placeholder="请输入担保归档人员"
        v-model="secureFiler"
        option-filter-prop="children"
        style="width: 300px"
        class="email-input"
      >
        <a-select-option
          v-for="item in selectList"
          :key="item.username"
          :value="item.username"
          :label="item.username"
        >
          {{ item.username }}
        </a-select-option>
      </a-select>

      <a-button type="primary" @click="handleSave('5')">确定</a-button>
    </div>
  </a-card>
</template>

<script>
import { getEmails, saveEmails, getGuarantee } from './api'

export default {
  data() {
    return {
      bpm: '',
      amount: '',
      limitOverAmount: '',
      loanOverLimit: '',
      secureFiler: '',
      selectList: [],
    }
  },
  mounted() {
    this._getEmails()
    this._getGuarantee()
  },
  methods: {
    async _getGuarantee() {
      const { data } = await getGuarantee()
      this.selectList = data
    },
    _getEmails() {
      getEmails().then(
        ({
          data: { bpm, amount, limitOverAmount, loanOverLimit, secureFiler },
        }) => {
          this.bpm = bpm
          this.amount = amount
          this.limitOverAmount = limitOverAmount
          this.loanOverLimit = loanOverLimit
          this.secureFiler = secureFiler
        },
      )
    },
    handleSave(type) {
      let emails = ''
      if (type === '1') {
        emails = this.bpm
      } else if (type === '2') {
        emails = this.amount
      } else if (type === '3') {
        emails = this.limitOverAmount
      } else {
        emails = this.secureFiler
      }
      saveEmails({ emails: emails, type: type }).then(({ message }) => {
        this.$notification.success({ message: '提示', description: message })
      })
    },
  },
}
</script>

<style lang="less" scoped>
.email-input {
  width: 400px;
  margin-right: 20px;
}
</style>
